import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'dibs-react-intl';
import styles from '../../styles/main.scss';

// components
import Select from '../inputs/Select';

const messages = defineMessages({
    placeholder: {
        id: 'dc.AddressForm.CityState.placeholder',
        defaultMessage: 'City & State',
    },
});

const CityState = ({
    value,
    options,
    fieldSize,
    isBlurred,
    disabled,
    error,
    onChange,
    onBlur = () => {},
}) => {
    const intl = useIntl();
    return (
        <Select
            name="cityStateOptions"
            dataTn="city-state"
            value={value}
            wrapperClass={styles.right}
            options={options}
            placeholder={intl.formatMessage(messages.placeholder)}
            fieldSize={fieldSize}
            isBlurred={isBlurred}
            disabled={disabled}
            error={error}
            onChange={onChange}
            onBlur={onBlur}
        />
    );
};

CityState.propTypes = {
    value: PropTypes.string.isRequired,
    error: PropTypes.string,
    options: PropTypes.array.isRequired,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    isBlurred: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func,
};

export default CityState;
